<div class="affordability">
  <h2>Affordability Check</h2>

  @if (loading) {
    <div class="apg-loading">
      <ion-spinner></ion-spinner>

      <div>
        <i>{{ message }}</i>
      </div>
    </div>
  } @else {
    @switch (mode) {
      @case ("premium") {
        <form #ciForm="ngForm">
          <app-question [question]="premiumQuestion"></app-question>

          <div class="summary__buttons">
            <ion-button (click)="setPremium(premiumQuestion.answer)">
              Continue
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </div>
        </form>
      }

      @case ("institutions") {
        <app-apg-open-banking-institutions (selectInst)="selectInstitution($event)" [mode]="mode"> </app-apg-open-banking-institutions>
      }

      @case ("accounts") {
        <app-apg-open-banking-institutions (selectAcc)="selectAccount($event)" [accounts]="accounts" [mode]="mode">
        </app-apg-open-banking-institutions>
      }

      @case ("days") {
        <app-apg-select-premium-day [days]="days" (continue)="selectDay($event)"></app-apg-select-premium-day>
      }

      @case ("complete") {
        <div>
          <p>Affordability check complete, you selected the {{ selectedDay | ordinalSuffix }} as your debit order date</p>
        </div>
      }
    }
  }

  <div *ngIf="error" class="error">
    <ion-label>{{ error }}</ion-label>
  </div>
</div>
